// extracted by extract-css-chunks-webpack-plugin
module.exports = {"arabicSpaceAfter":"formatted-time__arabicSpaceAfter--1KGcF"};